import { combineReducers } from '@wordpress/data'

export function product(state = null, action) {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case 'SET_PRODUCT':
      return action.product
  }

  return state
}

export function fatalError(state = [], action) {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case 'SET_FATAL_ERROR':
      return action.error
  }

  return state
}

/**
 * Reducer managing the selected frame.
 *
 * @param {Array} state
 * @param {Object} action
 * @return {Object}
 */
export function frames(state = [], action) {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case 'SET_FRAMES':
      return action.frames
  }

  return state
}

/**
 * Reducer managing the selected frame.
 *
 * @param {Object|null} state
 * @param {Object} action
 * @return {Object}
 */
export function selectedFrame(state = null, action) {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case 'SET_SELECTED_FRAME':
      return action.frame
    case 'CLEAR_SELECTED_FRAME':
      return null
  }

  return state
}

export function uploadedImages(state = [], action) {
  return []
}

export default combineReducers({
  product,
  frames,
  selectedFrame,
  uploadedImages,
  fatalError
})
